import mapDispatchToProps from './actions';

export default dispatch => mapDispatchToProps(dispatch);
